<template>

  <b-modal hide-footer title="Download App Onlaine" @hide="onHidden()" id="modal-download-app">

    <b-row class="mt-3">
      <b-col cols="12" class="d-flex justify-content-center">
        <a href="https://linktr.ee/onlainetech" @click="closeDialog()" target="_blank">
          <img src="https://static.onlaine.com.br/images/linktree.png" style="max-width: 250px"/>
        </a>
      </b-col>

    </b-row>

    <b-row class="mt-3 mb-4">

      <b-col cols="6" class="d-flex justify-content-center">

          <a href="https://play.google.com/store/apps/details?id=com.onlaine.app" @click="closeDialog()" target="_blank">
            <img src="https://static.onlaine.com.br/images/playstore.png" style="width: 180px" class="icon-stores"/>
          </a>

      </b-col>

      <b-col cols="6" class="d-flex justify-content-center">

          <a href="https://apps.apple.com/br/app/onlaine/id6478116349" @click="closeDialog()" target="_blank">
            <img src="https://static.onlaine.com.br/images/applestore.png" style="width: 180px" class="icon-stores"/>
          </a>

      </b-col>

    </b-row>


  </b-modal>

</template>
<script>
export default {
  name: 't-dialog-download-app',
  data() {
    return {
      status: "",
    }
  },

  methods: {

    closeDialog() {
      this.$bvModal.hide('modal-download-app')
    },
    onHidden(){
      this.$bvModal.hide('modal-download-app')
      this.$emit("hide")
    }


  }
}
</script>
